import React, { FC } from 'react';
import styled from 'styled-components';

import Button, { IButtonProps } from '@ui/atoms/Button';
import FlexColumn, { IFlexColumn } from '@ui/atoms/FlexColumn';
import TextLink from '@ui/atoms/TextLink';
import WYSIWYGContent, { IWYSIWYGContentProps } from '@ui/atoms/WYSIWYGContent';

import aligned from '@ui/styled/Aligned';
import fullWidth from '@ui/styled/FullWidth';
import spaced from '@ui/styled/Spaced';

import { IPageProps } from '@folx-types/flow-steps';

export interface IBillPayRedirectPageContent {
	pageInfo: string;
	backButtonLabel: string;
	helpCenterLabel: string;
}

interface IBillPayRedirectProps extends IPageProps {
	pageContent: IBillPayRedirectPageContent;
}

const SpacedWysiwyg = spaced<IWYSIWYGContentProps>(WYSIWYGContent);
const AlignedColumn = aligned<IFlexColumn>(FlexColumn);
const FullWidthButton = fullWidth<IButtonProps>(Button);

const BackButton = styled(FullWidthButton)`
	max-width: 32rem;
`;

const BillPayRedirect: FC<IBillPayRedirectProps> = ({ pageContent }) => {
	const { pageInfo, backButtonLabel, helpCenterLabel } = pageContent;

	return (
		<FlexColumn>
			<SpacedWysiwyg dangerouslySetInnerHTML={{ __html: pageInfo }} marginBottom="xxl" />
			<AlignedColumn alignItems="center" gap="sm">
				<BackButton variant="secondary" label={backButtonLabel} href="/app/member/billing" />
				<TextLink label={helpCenterLabel} href={process.env.GATSBY_SUPPORT_LINK!} />
			</AlignedColumn>
		</FlexColumn>
	);
};

export default BillPayRedirect;
